<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-percent mr-2" />PPH</h5>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="Status">
                        <b-form-select v-model="filter.isActive" :options="optIsActiveFilter" @change="getItems(1)" />
                    </b-form-group>
                </b-col>
                <b-col md="8" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button variant="success" @click="openCreateModal">
                            <i class="fa fa-plus mr-2" />PPH Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
            >
                <template v-slot:empty>Tidak ada data PPH.</template>
                <template v-slot:cell(percentage)="row">
                    {{ row.item.percentage }}%
                </template>
                <template v-slot:cell(direction)="row">
                    <b-badge :variant="row.item.direction === 'plus' ? 'success' : 'danger'">
                        {{ row.item.direction === 'plus' ? 'Plus (+)' : 'Minus (-)' }}
                    </b-badge>
                </template>
                <template v-slot:cell(is_active)="row">
                    <b-badge :variant="row.item.is_active ? 'success' : 'secondary'">
                        {{ row.item.is_active ? 'Aktif' : 'Nonaktif' }}
                    </b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="warning" class="mr-1" v-b-tooltip.hover title="Edit"
                        @click="openEditModal(row.item)">
                        <i class="fa fa-pencil" />
                    </b-button>
                    <b-button size="sm" variant="danger" v-b-tooltip.hover title="Hapus"
                        @click="confirmDelete(row.item)">
                        <i class="fa fa-trash" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="pageSizeOptions"
                @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>

        <b-modal id="m-create" title="Tambah PPH Baru" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nama PPH" description="Contoh: PPH 2.5%">
                <b-input v-model="input.name" maxlength="100" />
            </b-form-group>
            <b-form-group label="Persentase (%)" description="Nilai positif. Contoh: 2.5">
                <b-input v-model="input.percentage" type="number" min="0" step="0.01" />
            </b-form-group>
            <b-form-group label="Plus / Minus">
                <b-form-select v-model="input.direction" :options="optDirection" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmCreate">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-edit" title="Edit PPH" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nama PPH">
                <b-input v-model="edit.name" maxlength="100" />
            </b-form-group>
            <b-form-group label="Persentase (%)">
                <b-input v-model="edit.percentage" type="number" min="0" step="0.01" />
            </b-form-group>
            <b-form-group label="Plus / Minus">
                <b-form-select v-model="edit.direction" :options="optDirection" />
            </b-form-group>
            <b-form-group label="Status">
                <b-form-select v-model="edit.isActive" :options="optIsActive" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEdit">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'list-pph',
    data() {
        return {
            initStatus: 0,
            isBusy: false,
            isSubmitting: false,

            filter: {
                isActive: ""
            },

            input: {
                name: "",
                percentage: "",
                direction: "plus",
                isActive: true
            },

            edit: {
                id: null,
                name: "",
                percentage: "",
                direction: "plus",
                isActive: true
            },

            items: [],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,

            fields: [
                { key: "name", label: "Nama" },
                { key: "percentage", label: "Persentase" },
                { key: "direction", label: "Plus / Minus" },
                { key: "is_active", label: "Status" },
                { key: "action", label: "Aksi" }
            ],

            optDirection: [
                { value: "plus", text: "Plus (+)" },
                { value: "minus", text: "Minus (-)" }
            ],

            optIsActive: [
                { value: true, text: "Aktif" },
                { value: false, text: "Nonaktif" }
            ],

            optIsActiveFilter: [
                { value: "", text: "Semua" },
                { value: "true", text: "Aktif" },
                { value: "false", text: "Nonaktif" }
            ],

            pageSizeOptions: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 50, text: "50" }
            ]
        }
    },

    methods: {
        init() {
            this.initStatus = 0
            this.getItems(1).then(() => {
                this.initStatus = 1
            }).catch(() => {
                this.initStatus = -1
            })
        },

        getItems(page = 1) {
            this.isBusy = true
            this.currentPage = page

            const params = {
                page: this.currentPage,
                per_page: this.perPage
            }
            if (this.filter.isActive !== "") params.is_active = this.filter.isActive

            return this.$axios.get("pphs", { params }).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isBusy = false
            })
        },

        openCreateModal() {
            this.input = { name: "", percentage: "", direction: "plus", isActive: true }
            this.$bvModal.show("m-create")
        },

        confirmCreate() {
            if (this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }
            if (this.$helper.isBlank(this.input.percentage) || Number(this.input.percentage) < 0) {
                return this.$helper.toastError(this, "Persentase harus diisi dan tidak boleh negatif!")
            }

            const confirmed = confirm("Tambah PPH baru ini?")
            if (!confirmed) return

            this.isSubmitting = true
            this.$axios.post("pphs", {
                name: this.input.name,
                percentage: Number(this.input.percentage),
                direction: this.input.direction
            }).then(() => {
                this.$helper.toastSuccess(this, "PPH berhasil ditambahkan!")
                this.$bvModal.hide("m-create")
                this.getItems(1)
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },

        openEditModal(item) {
            this.edit = {
                id: item.id,
                name: item.name,
                percentage: item.percentage,
                direction: item.direction,
                isActive: !!item.is_active
            }
            this.$bvModal.show("m-edit")
        },

        confirmEdit() {
            if (this.$helper.isBlank(this.edit.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }
            if (this.$helper.isBlank(this.edit.percentage) || Number(this.edit.percentage) < 0) {
                return this.$helper.toastError(this, "Persentase harus diisi dan tidak boleh negatif!")
            }

            const confirmed = confirm("Simpan perubahan PPH ini?")
            if (!confirmed) return

            this.isSubmitting = true
            this.$axios.put("pphs/" + this.edit.id, {
                name: this.edit.name,
                percentage: Number(this.edit.percentage),
                direction: this.edit.direction,
                is_active: this.edit.isActive
            }).then(() => {
                this.$helper.toastSuccess(this, "PPH berhasil diubah!")
                this.$bvModal.hide("m-edit")
                this.getItems(this.currentPage)
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },

        confirmDelete(item) {
            const confirmed = confirm("Hapus PPH '" + item.name + "'? Tindakan ini tidak dapat dibatalkan.")
            if (!confirmed) return

            this.$axios.delete("pphs/" + item.id).then(() => {
                this.$helper.toastSuccess(this, "PPH berhasil dihapus!")
                this.getItems(this.currentPage)
            }).catch(error => {
                this.$helper.parseError(this, error)
            })
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(1)
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        }
    },

    created() {
        this.init()
    }
}
</script>
